import url from './url'
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: 'CharterAdmin'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    appBaseUrl: "http://localhost:8081",
    remoteServiceBaseUrl: url.endsWith('/') ? url.slice(0, -1) : url,
    // Izleme metrikleri ayri bir adresten okunur: VictoriaMetrics yalnizca
    // api.charterscanners.com sunucusunda 127.0.0.1'e bagli oldugu icin bu
    // uc nokta panelin kendi API'sinden degil oradan cevap verebilir.
    metricsBaseUrl: (() => {
        const m = process.env.VUE_APP_METRICS_API || url;
        return m.endsWith('/') ? m.slice(0, -1) : m;
    })()
}
export default AppConsts